<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Canteen Menu Category</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3">
            <p><b>Name</b></p>
            <v-text-field outlined dense type="text" v-model="name"></v-text-field>
          </v-col>
        </v-row>
        <v-row justify="center" dense v-if="name">
          <v-btn color="warning" @click="saveCanteenMenuCategory()" :loading="loader">Add</v-btn>
        </v-row>
      </v-card>
      <v-card class="box" v-if="canteen_manu_category_list != ''">
        <v-data-table :headers="headers" :items="canteen_manu_category_list">
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>Canteen Menu Category List</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <template v-slot:[`item.edit`]="{ item }">
            <v-avatar size="35">
              <v-icon class="mr-4 v-icon-size" color="red" @click="editDetail(item)">mdi-pencil</v-icon>
            </v-avatar>
          </template>
          <template v-slot:[`item.isactive`]="{ item }">
            <v-switch v-model="item.isactive" @change="toggleIsactive(item)"></v-switch>
          </template>
          <template v-slot:[`item.delete`]="{ item }">
            <v-avatar size="35">
              <v-icon class="mr-4 v-icon-size" color="red" @click="deleteMenuCategory(item)">mdi-trash-can</v-icon>
            </v-avatar>
          </template>
        </v-data-table>
      </v-card>

      <v-dialog v-model="dialog_edit" persistent scrollable="false" max-width="1200px"
        transition="dialog-bottom-transition">
        <v-card class="box">
          <v-toolbar flat class="toolbar">
            <v-toolbar-title>Edit Canteen Menu Type</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-row justify="center" dense>
              <v-col cols="12" sm="3">
                <p><b>Name</b></p>
                <v-text-field outlined dense type="text" v-model="editedItem.name" filled></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <br />
          <v-row justify="center">
            <v-btn color="primary" :loading="loader" @click="saveEditMenuCategory()">Update</v-btn>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary" @click="dialog_edit = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
  <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    loader: false,
    snackbar_msg: "",
    // extraBreadcrumbItems: [
    //   { text: "Menu Category", disabled: true, href: "" },

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    color: "",
    snackbar: false,
    overlay: false,
    name: "",
    canteen_manu_category_list:[],
    headers: [
      { text: "Sr No", value: "count" },
      { text: "Name", value: "name" },
      { text: "Is-active", value: "isactive" },
      { text: "Edit", value: "edit" },
      { text: "Delete", value: "delete" },
    ],
   
    dialog_edit: false,
    editedItem: {
      id: "",
      name: "",
    },
  }),
  methods: {
     deleteMenuCategory(item) {
      const data = {
        id: item.id,
      };
      this.overlay = true;
      axios
        .post("/Canteen/deleteMenuCategory", data)
        .then((res) => {
          if (res.data.flag == "YES") {
          (this.canteen_manu_category_list = res.data.canteen_manu_category_list),
            this.showSnackbar("green", "Deleted Successfully...");
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    toggleIsactive(item){
         const data = {
            id: item.id,
            isactive: item.isactive,
      };
      this.overlay = true;
      axios
        .post("/Canteen/toggleIsactiveMenuCategory", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            (this.canteen_manu_category_list = res.data.canteen_manu_category_list),
            this.showSnackbar("green", "Updated Successfully...");
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
   
    saveEditMenuCategory() {
      this.overlay = true;
      this.loader = true;
      axios
        .post("/Canteen/saveEditMenuCategory", this.editedItem)
        .then((res) => {
          if (res.data.flag == "YES") {
             (this.canteen_manu_category_list = res.data.canteen_manu_category_list),
            this.dialog_edit = false;
            this.showSnackbar("green", "Details Updated Successfully...");
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          this.loader = false;
        });
    },
    editDetail(item) {
      this.editedItem.id = item.id;
      this.editedItem.name = item.name;
      this.dialog_edit = true;
    },
    saveCanteenMenuCategory() {
      const data = {
        name:this.name,
      };
      this.overlay = true;
      axios
        .post("/Canteen/saveCanteenMenuCategory", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            (this.canteen_manu_category_list = res.data.canteen_manu_category_list)
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
            this.master_present = true;
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    onLoad() {
      axios
        .post("Canteen/getMenuCategoryList")
        .then((res) => {
          if (res.data.flag == "YES") {
            (this.canteen_manu_category_list = res.data.canteen_manu_category_list),
              (this.overlay = false);
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
/* .box2 {
  overflow-x: hidden;
  width: 98%;
} */
</style>